import { useEffect } from 'react';

// An Escape inside an open popup closes the popup, not the panel under it.
const POPUPS = [
  '[role="menu"]',
  '[role="listbox"]',
  '[role="combobox"][aria-expanded="true"]',
  '.bx--list-box--expanded',
  '.flatpickr-calendar',
  '.bx--modal.is-visible',
].join(', ');

// For panels with no keyboard close of their own: Escape closes them as it does a modal.
export const useEscapeToClose = (open: boolean, onClose?: () => void) => {
  useEffect(() => {
    if (!open || !onClose) return undefined;
    const close = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      const { target } = event;
      if (target instanceof Element && target.closest(POPUPS)) return;
      onClose();
    };
    // Capture: a Carbon list box stops every Escape from bubbling.
    document.addEventListener('keydown', close, true);
    return () => document.removeEventListener('keydown', close, true);
  }, [open, onClose]);
};
